import request from '../helpers/request';
import {
  addFilmToFavoriteAPI,
  changeAvatarAPI,
  deleteFilmFromFavoriteAPI,
  editProfileAPI,
  getBalanceAPI,
  getProfileAPI,
  registerAPI, sendAuthenticationLetterAPI,
  useBonusPromoCodeAPI,
} from '../helpers/api';


export const getProfile = async (data) => {
  return await request(getProfileAPI(data));
};


export const getBalance = async (data) => {
  return await request(getBalanceAPI(data));
};

export const changeAvatar = async (data) => {
  return await request(changeAvatarAPI(), 'POST', data);
};

export const editProfile = async (data) => {
  return await request(editProfileAPI(), 'POST', data);
};

export const register = async (data) => {
  return await request(registerAPI(), 'POST', data);
};

export const useBonusPromoCode = async (data) => {
  return await request(useBonusPromoCodeAPI(), 'POST', data);
};

export const sendAuthenticationLetter = async (data) => {
  return await request(sendAuthenticationLetterAPI(), 'POST', data);
};

export const addFilmToFavorite = async (data) => {
  return await request(addFilmToFavoriteAPI(), 'POST', data);
};

export const deleteFilmFromFavorite = async (data) => {
  return await request(deleteFilmFromFavoriteAPI(), 'POST', data);
};
